import React from "react";

const DiagonalLinesBackground = ({
  children,
  bgColor = "#FB923C",
  isCardCover = false,
}) => {
  return (
    <div
      className={`relative ${
        !isCardCover ? "min-h-screen" : "h-20"
      }  w-full flex items-center justify-center overflow-hidden`}
      style={{ backgroundColor: `${bgColor}33` }} // Hintergrundfarbe mit 20% Opazität
    >
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="diagonalLines"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45)"
          >
            <line
              x1="0"
              y1="0"
              x2="0"
              y2="40"
              stroke={bgColor}
              strokeWidth="2"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#diagonalLines)" />
      </svg>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default DiagonalLinesBackground;
